import { render, staticRenderFns } from "./GenericList.vue?vue&type=template&id=59f46324&scoped=true"
import script from "./GenericList.vue?vue&type=script&lang=js"
export * from "./GenericList.vue?vue&type=script&lang=js"
import style0 from "./GenericList.vue?vue&type=style&index=0&id=59f46324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f46324",
  null
  
)

export default component.exports